export default class Animate {
    constructor($element, $scrollParent) {
        this.$element = $element;
        this.$scrollParent = $scrollParent ?
                $scrollParent:
                window;
        this.treshold = $element.dataset.animateTreshold ?
                $element.dataset.animateTreshold :
                this.getDefaultTreshold();

        this.checkAnimate = this.checkAnimate.bind(this);

        this.checkAnimate();
        this.$scrollParent.addEventListener('scroll', this.checkAnimate);
    }

    checkAnimate() {
        let elPosition = (this.$element.getBoundingClientRect().top - window.innerHeight) + parseInt(this.treshold);

        if (elPosition <= 0 && ! this.$element.classList.contains('animated')) {
            this.$element.classList.add('animated');
        }

        if((this.$element.getBoundingClientRect().top - window.innerHeight) > 0 && this.$element.classList.contains('animated')) {
            this.$element.classList.remove('animated');
        }
    }

    getDefaultTreshold() {
        if(window.innerWidth <= 768) {
            return 75;
        }

        return 150;
    }
}